import Tooltip from "@8x8/oxygen-tooltip";
import LabeledInput from "@/react/components/LabeledInput";

const ValidatedInput = (props) => {
  const { error, ...other } = props;
  return error ? (
    <Tooltip title={error}>
      <LabeledInput hasError={true} {...other} />
    </Tooltip>
  ) : (
    <LabeledInput {...other} />
  );
};

export default ValidatedInput;
